export default "__VITE_ASSET__ByUYfzRR__"